export const APOST_EMAIL_MSG =
  'Unfortunately, we can’t accept an email address with an apostrophe. Please enter an alternate email or call us on 1300 265 374 to discuss your options.';

export const checkEmailForSingleQuote = (email: string) => email.includes("'");
